"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_INITIAL_STATE = exports.SET_DIRECTORY_TABLE_CONFIG = exports.SET_DIRECTORY_RESULTS = void 0;
exports.SET_DIRECTORY_RESULTS = 'SET_DIRECTORY_RESULTS';
exports.SET_DIRECTORY_TABLE_CONFIG = 'SET_DIRECTORY_TABLE_CONFIG';
exports.SET_INITIAL_STATE = 'SET_INITIAL_STATE';
